import { useTheme } from '@mui/material/styles';

export const useStyles = () => {
  const theme = useTheme();
  return {
    gridContainer: {
      color: theme.colorTokens.onSurfaceTextTitle,
    },
    imagePreferred: {
      cursor: 'pointer',
    },
    selectImgPreferred: {
      border: `solid 1.5px ${theme.palette.success.main}`,
    },
    notSelectImgPreferred: {
      filter: 'opacity(0.7)',
    },
    button: {
      borderRadius: '40px',
      textTransform: 'initial',
      fontWeight: 600,
      boxShadow: 'none',
      display: 'inline-block',
      '& > .MuiButton-label': {
        display: 'inline-block',
        verticalAlign: 'sub',
      },
    },
    dialogButton: {
      textTransform: 'uppercase',
      minWidth: '130px',
      display: 'inline-block',
      '& > .MuiButton-label': {
        display: 'inline-block',
        verticalAlign: 'sub',
      },
      [theme.breakpoints.down('sm')]: {
        minWidth: '110px',
      },
    },
    itemCenter: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: theme.colorTokens.onSurfaceTextTitle,
    },
    rootButton: {
      borderRadius: '24px',
      border: `1px solid ${theme.palette.common12}`,
      marginBottom: '32px',
    },
    buttonLabel: {
      textTransform: 'none',
      paddingLeft: '20px',
      paddingRight: '20px',
    },
  };
};
